import { Link } from "react-router-dom"
import "./OfferingItem.css"
import API_CONFIG from "../config/api";

const OfferingItem = ({ image, title, description, link }) => {
  return (
    <Link to={link} className="offering-item">
      <div className="offering-image">
        <img src={`${API_CONFIG.IMAGES_URL}/${image}`} alt={title} />
      </div>
      <h3 className="offering-title">{title}</h3>
      <p className="offering-description">{description}</p>
    </Link>
  )
}

export default OfferingItem